import { useEffect, useState } from "react";

const TARGET = new Date("2026-09-22T19:00:00-04:00").getTime();

const getParts = () => {
  const diff = Math.max(0, TARGET - Date.now());
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000) % 24,
    minutes: Math.floor(diff / 60000) % 60,
    seconds: Math.floor(diff / 1000) % 60,
    live: diff <= 0,
  };
};

export const Countdown = () => {
  const [t, setT] = useState(getParts);

  useEffect(() => {
    const id = setInterval(() => setT(getParts()), 1000);
    return () => clearInterval(id);
  }, []);

  if (t.live) {
    return (
      <p data-testid="hero-countdown" className="mt-6 font-accent text-2xl text-clay">
        we're live — come join us
      </p>
    );
  }

  const units = [
    ["days", t.days],
    ["hours", t.hours],
    ["min", t.minutes],
    ["sec", t.seconds],
  ];

  return (
    <div data-testid="hero-countdown" className="mt-6">
      <div className="flex flex-wrap gap-3">
        {units.map(([label, value]) => (
          <div
            key={label}
            data-testid={`countdown-${label}`}
            className="min-w-[72px] rounded-2xl border border-line bg-white px-4 py-3 text-center"
          >
            <div className="font-heading text-2xl leading-none text-ink tabular-nums">
              {String(value).padStart(2, "0")}
            </div>
            <div className="mt-1 text-xs uppercase tracking-wide text-stone-muted">{label}</div>
          </div>
        ))}
      </div>
      <p className="mt-3 font-accent text-xl text-clay">until we go live</p>
    </div>
  );
};
